import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailNotificationComponent } from '../../components/email-notification/email-notification.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-single-notification-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './single-notification.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailNotificationComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class SingleNotificationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<SingleNotificationTemplateData>;
}

export type SingleNotificationTemplateData = {
  title: string;
  p1: string;
  avatar_url: string;
  notification_html: string;
  button_link: string;
  button_text: string;
  footer_p1: string;
  footer_link: string;
  footer_link_text: string;
};

export const SingleNotificationTemplateMocks: SingleNotificationTemplateData[] = [
  {
    title: 'Unread notification',
    p1: 'You have an unread notification in ACME.',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    notification_html:
      '<b>Olivia Novak</b> added a Team Note to candidate <a href="#"><b>Bruce Davos</b></a>.',
    button_link: 'http://recruitee.com',
    button_text: 'Go to notifications',
    footer_p1: 'This email was sent by Recruitee.com',
    footer_link: 'http://recruitee.com',
    footer_link_text: 'Change your notification settings',
  },
];
